import React from 'react'
import CustomerList from './CustomerList'

function UserPayment({ userProfile }) {
  return (
    <div>
      <CustomerList userProfile={userProfile} />
    </div>
  )
}

export default UserPayment
